"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Classy: function() {
        return Classy;
    },
    ClassyDynamic: function() {
        return ClassyDynamic;
    },
    ClassyPlaceholder: function() {
        return ClassyPlaceholder;
    }
});
const Classy = class {
    constructor(obj){
        Object.assign(this, obj);
        // eslint-disable-next-line no-constructor-return
        return new Proxy(this, {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set: (object, key, value)=>{
                object[key] = value;
                return true;
            }
        });
    }
};
const ClassyPlaceholder = class {
    constructor(){
        throw new Error('This cannot be constructed');
    }
};
const ClassyDynamic = class {
    constructor(){
    /* noop */ }
};

//# sourceMappingURL=classy.js.map